// Metatrybe Bot Knowledge Base
export const BOT_KNOWLEDGE = {
  company: {
    name: "Metatrybe",
    tagline: "High-converting digital experiences, custom web/app development, and UI/UX design.",
    description: "Metatrybe is a premier digital product studio specializing in website design & development, mobile/web app development, no-code solutions (Framer/Webflow), and custom e-commerce stores.",
    supportEmail: "hello@metatrybe.com",
    process: [
      "1. Discovery & Strategy call",
      "2. UX/UI Wireframing & Design",
      "3. Full-stack development & testing",
      "4. Launch & 30-day post-launch support"
    ],
    guarantee: "Unlimited revisions until you are 100% satisfied with the outcome.",
    support: "30-day post-launch support included with all plans."
  },

  pricing: [
    {
      id: "website-design-dev",
      title: "Website Design & Dev",
      price: "$4,500",
      description: "Modern and eye-catching website or landing page design (Full-Cycle / Blended).",
      features: [
        "1-15 unique main page templates",
        "1-10 secondary pages",
        "UX/UI design + development",
        "High-converting architecture + speed optimization",
        "Custom CMS engine",
        "Multi-step forms, security, QA and support",
        "Unlimited revisions until you're satisfied"
      ],
      extras: "$100 for extra each page | $200 Lottie/Video animation"
    },
    {
      id: "ux-ui-design",
      title: "UX/UI Design",
      price: "$3,500",
      description: "User-friendly, modern and seamless web, mobile, or SaaS app design.",
      features: [
        "Up to 1-20 core screens/pages",
        "UI Library, style guide & design system, autolayout",
        "Premium / Licensed stock imagery",
        "Light & Dark mode design",
        "Easy handoff & collaboration with devs",
        "Ongoing 30-day post-launch support",
        "Unlimited revisions until satisfied"
      ],
      extras: "$100 Interactive Figma prototype"
    },
    {
      id: "no-code-dev",
      title: "No-Code Development",
      price: "$2,000",
      description: "Website developed in Framer, Webflow, WordPress, or custom HTML/CSS/JS.",
      features: [
        "1-7 screens/pages",
        "UI animations / interactions",
        "On-page and scroll animation",
        "CMS setup (blogs, team, case studies)",
        "Seamless integrations (CRM, Zapier)",
        "30-day post-launch support",
        "Unlimited revisions"
      ],
      extras: "$300 for simpler pages | $1,000 for complex pages | $200 Lottie animation"
    },
    {
      id: "app-development",
      title: "App Development",
      price: "$6,500+",
      description: "Full-stack Web or Mobile app development tailored to your enterprise needs.",
      features: [
        "Functional web software application",
        "Database architecture & Custom API integrations",
        "User authentication & payment gateways",
        "Native iOS & Android apps from a single codebase",
        "Maximum security compliance",
        "Unlimited revisions"
      ],
      extras: "Maintenance & support from $3,000/mo + dedicated project manager"
    },
    {
      id: "e-commerce",
      title: "E-Commerce Store",
      price: "$5,000+",
      description: "E-commerce store built in Shopify, WooCommerce, WordPress, Wix, or custom stack.",
      features: [
        "1-10 unique main page templates",
        "Product & Categories pages",
        "Payment gateways + Checkout process",
        "Database architecture & Custom API integrations",
        "Maximum security compliance",
        "Unlimited revisions"
      ],
      extras: "Maintenance & support from $3,000/mo"
    }
  ],

  services: [
    {
      name: "Website Design & Development",
      desc: "Custom high-converting marketing sites, landing pages, and web applications built with React, Next.js, and modern animation engines like GSAP and Framer Motion."
    },
    {
      name: "UX/UI Product Design",
      desc: "Pixel-perfect mobile and desktop interfaces, full design systems, Figma prototypes, and micro-interactions."
    },
    {
      name: "No-Code & CMS Development",
      desc: "Ultra-fast websites built using Webflow, Framer, WordPress, or modern static site engines for easy content updates."
    },
    {
      name: "Web & Mobile App Development",
      desc: "Scalable full-stack SaaS apps, iOS/Android mobile apps, secure APIs, and database architectures using Node.js, Express, and MongoDB."
    },
    {
      name: "E-Commerce Solutions",
      desc: "Custom online storefronts with seamless checkout experiences, product catalog management, and payment gateway integration (Stripe, PayPal, etc.)."
    }
  ],

  quickPrompts: [
    { label: "Pricing & Plans", intent: "pricing" },
    { label: "Services Offered", intent: "services" },
    { label: "View Portfolio", intent: "portfolio" },
    { label: "Get a Quote / Book Call", intent: "lead_start" },
    { label: "Contact Us", intent: "contact" }
  ],

  faqs: [
    {
      keywords: ["revision", "revisions", "change", "modify"],
      answer: "We offer **unlimited revisions** on all our design and development packages until you are 100% satisfied with the result!"
    },
    {
      keywords: ["timeline", "how long", "time", "duration"],
      answer: "Project timelines depend on complexity:\n- No-Code Websites: 1-2 weeks\n- Custom Web Design & Dev: 2-4 weeks\n- Mobile / Web Apps: 4-8 weeks"
    },
    {
      keywords: ["discount", "deal", "offer", "cheaper"],
      answer: "We offer tailored packages depending on your scope. You can also start with our No-Code package starting at **$2,000** or request a custom quote!"
    },
    {
      keywords: ["support", "after launch", "maintenance"],
      answer: "All our plans come with **30 days of post-launch support**. We also offer dedicated monthly maintenance packages starting at $3,000/mo."
    },
    {
      keywords: ["tech", "stack", "react", "node", "technology", "tools"],
      answer: "Our tech stack includes **React, Node.js, Express, MongoDB, GSAP, Framer Motion, Webflow, Framer, Shopify, and Figma**."
    }
  ]
};
